import { Box, Typography } from '@mui/material';
import { User } from '@uplift/api';
import { useTimezone } from '@uplift/contexts';
import { useUserQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';

export type MedicalNoteSubmittedByProps = {
  submittedAt?: string | null;
  user: Pick<User, 'firstName' | 'lastName'>;
};
export const MedicalNoteSubmittedBy: React.VFC<MedicalNoteSubmittedByProps> = ({ submittedAt, user }) => {
  const timezone = useTimezone();

  if (!submittedAt) {
    return null;
  }

  const submissionDate = CalendarDateService.date(submittedAt).tz(timezone);

  if (!submissionDate.isValid()) {
    return null;
  }

  return (
    <Box my={3}>
      <Typography>
        Submitted by {user.firstName} {user.lastName} on {submissionDate.format('MM/DD/YYYY, hh:mm a')}
      </Typography>
    </Box>
  );
};


export const MedicalNoteSubmittedBySimple: React.VFC<{ userId: string; submittedAt?: string }> = ({ userId, submittedAt }) => {
  const { data: user } = useUserQuery(userId, { suspense: true });


  if (!user) {
    return null;
  }

  return (
    <Box px={2}>
      <MedicalNoteSubmittedBy
        user={user}
        submittedAt={submittedAt}
      />
    </Box>
  );
};
